'use client';

import React from 'react';
import { useUnits, UnitType } from '../contexts/UnitContext';

/**
 * Client-side unit toggle component.
 * Extracted from ToolContainer to allow it to be a Server Component.
 */
export const UnitToggle: React.FC = () => {
    const { activeUnit, setActiveUnit } = useUnits();

    return (
        <div className="flex items-center gap-1 bg-stone-100 p-1 rounded-xl border border-stone-200 self-start md:self-end mb-1">
            {(['g', 'oz', 'kg', 'lb'] as UnitType[]).map((unit) => (
                <button
                    key={unit}
                    onClick={() => setActiveUnit(unit)}
                    aria-label={`Set unit to ${unit === 'g' ? 'grams' : unit === 'oz' ? 'ounces' : unit === 'kg' ? 'kilograms' : 'pounds'}`}
                    className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                        activeUnit === unit
                            ? 'bg-brand-pink text-white shadow-sm'
                            : 'text-brand-text-body/60 hover:bg-white hover:text-brand-pink'
                    }`}
                >
                    {unit.toUpperCase()}
                </button>
            ))}
        </div>
    );
};
